import { render } from "./export.svg?vue&type=template&id=1be452c5"
const script = {}
script.render = render

export default script